module.exports = __webpack_public_path__ + "img/car-hero-mobile-1.7bf23e7.webp";